import Amplify from "aws-amplify";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import Vue from "vue";
import Vuelidate from "vuelidate";
import App from "./App.vue";
import awsmobile from "./config/backend-exports.json";
import vuetify from "./plugins/vuetify";
import router from "./router";
import { store } from "./store";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Vuelidate);

Amplify.configure(awsmobile);

Vue.config.productionTip = false;

const v = new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
